module.exports = __webpack_public_path__ + "static/media/cockpit_icon4.d7f82ab9.svg";